import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions as trackingDataActions } from '../store';

interface AuthLayoutProps {
  children: React.ReactNode;
  trackingData?: any;
};

const Scripts = () => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          if("IntersectionObserver"in window)document.addEventListener("DOMContentLoaded",(function(){const e=document.querySelectorAll(".lazy-load-bgimage"),t=new IntersectionObserver((function(e){e.map((e=>{e.isIntersecting&&(e.target.style.backgroundImage="url('"+e.target.dataset.bgimage+"')",t.unobserve(e.target))}))}),{rootMargin:"100px"});e.forEach((e=>t.observe(e)))}));else{document.querySelectorAll(".lazy-load-bgimage").forEach((e=>{e.style.backgroundImage="url('"+e.dataset.bgimage+"')"}))}
        `,
      }}
    />
  )
}
/**
 * This is a pass-through component for handling Auth and Tracking Data and storing it in Redux
 * @param props 
 * @returns {JSX.Element}
 */
const AuthLayout = (props: AuthLayoutProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(trackingDataActions.loadTrackingDataThunk());
  }, [dispatch]);
  
  const { children } = props;
  return <><Scripts />{children}</>;
};

export default AuthLayout;